export const acknowledgment = [
  {
    title:
      "Application for Bachelor of Dental Medicine Study Program Academic Year 2025 – 2026",
    text: `Admission minimum requirements:`,
    subtext: `BDM- Program admission for the academic year 2025/2026 is a competitive and
according to the college capacity and seats availability, noting that achieving the minimum
requirements and conditions of admission or submitting the required documents does not
mean acceptance or admission to the university`,
    termsAndConditions: [
      {
        title: "Applying requirements",
        conditions: [
          {
            text: `The student must have a general average 90% in secondary (high school) – scientific
section - or above or its equivalent in the State of Kuwait and recognized by the
American University for Medical Sciences`
          },
          //           {
          //             text: `The student must have 80% in the following subjects in high school:
          // Biology - Physics - Chemistry`
          //           },
          //           {
          //             text: `Passing the IELTS English language exam and achieving a score of at least 6 or its
          // equivalent.`
          //           },
          // {
          //   text: "Students with scoring 80–89% in high school AGPA may apply for probationary Admission (they have to pass all first-year courses of study)"
          // },
          {
            text: `English Language placement test with a minimum score of 80 % or minimum IELTS 5.5 or its equivelent`
          },
          {
            text: `Submit the required documents to the university administration.`
          },
          {
            text: `Pay non-refundable fees as(application fees, Admission/Placement test fees, etc...).`
          },
          {
            text: `Passing the personal interview and admission exams.`
          },
          // {
          //   text: `Seat reservation payment will be required before receiving acceptance letter for self-funded students (it will be deducted from tuition fees)`
          // }
        ]
      }
    ],
    requiredDoc: [
      {
        title: "Required Documents for application (Upload) All in PDF Format:",
        conditions: [
          {
            text: `Copy of Official grade transcript or certified copy - Original High school certificate.`
          },
          {
            text: `Equivalency of high school degree issued by the Ministry of Education in Kuwait (for private school graduates).`
          },
          {
            text: `Valid IELTS/TOEFL score report (if available) (no older than two years).`
          },
          {
            text: `Copy of birth certificate.`
          },
          {
            text: `Valid National Civil ID (no less than 3 months validity) and valid passport photocopies.`
          },
          {
            text: `Valid Security cards (for non-Kuwaitis)`
          },
          {
            text: `Valid National Civil ID and valid passport photocopies of parents / or legal guardian.`
          },
          {
            text: `Personal photo 4*6.`
          },

        ],
        subtitle: "additional documents may be required from admission office in the College of Dental Medicine."
      }
    ],
    importantNotes: [
      {
        title: "Important Notes",
        subTitle: "How to apply for Bachelor of Dental Medicine Program (B.D.M)",
        for: "Only for self sponsored students",
        points: [
          {
            text: "Step 1: Request an application form",
            content:
              "Fill all the information & upload all required documents and submit your request. Due to high demand and limited number of seats, only eligible candidates will be contacted to continue their application (within 1 month)."
          },
          // {
          //   text: "Step 2: Eligible Candidates will proceed to fill Admission Application Form & pay application fees and placement test fees",
          //   content: ""
          // },
          // {
          //   text: "Step 3: Admission",
          //   content:
          //     "All decisions of admission (within 1 month) of offers and rejections are made at the discretion of the Admission Committee. All decisions by the Admission Committee are final."
          // }
        ],
        annualFees: {
          text: "9000 KD"
        },
        offerAnnualFees: {
          text: "8000 KD"
        },
        importantPoints: {
          text: "The University reserves the right to increase or modify the Tuition fee upon approval of the Private University Council - Ministry of Higher Education and the University Board of Trustees  "
        }
      }
    ],
    notes: [
      {
        title: "Note",
        points: [
          {
            text: `Admission is extremely competitive and is based on the strength of the applicant pool
and the available capacity.`
          },
          {
            text: `Note that fulfilling the requirements and admission conditions does not
mean acceptance into the university.`
          }
        ]
      }
    ]
  }
];
